import { MarginIncident } from "@/features/treasury/treasury";

export default function TreasuryLendingIncidentPage() {
  return <MarginIncident />;
}
